export class ConfigError extends Error {
  constructor(message?: string | undefined) {
    super(message && `Invalid config: ${message}`);
  }
}
